import { type InjectionKey } from "@nuxtjs/composition-api";

export const videoDebugKey: InjectionKey<boolean> = Symbol("videoDebugKey");
